module.exports = __webpack_public_path__ + "img/uid-guide2.514881a.jpg";